import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0080',
    ecrans: ['00-2']
});
